<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button *ngIf="!visibilitySpinner" type="button" class="btn btn-outline-success" [disabled]="!resultCertificadoSedeExporSl?.ResultList || resultCertificadoSedeExporSl?.ResultList.length === 0"
                title="Exportar" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Buscador de Certificados Sede SL</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Desde</label>
                                    <p-calendar formControlName="FechaDesde" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Hasta</label>
                                    <p-calendar formControlName="FechaHasta" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigo">Código Solicitud</label>
                                    <input formControlName="Codigo" name="CodigoSolicitud" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpTipo">Tipo</label>
                                    <ng-select [items]="listTipoSolicitud"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoSolicitudEx"
                                               loadingText="Cargando..."
                                               [readonly]="!listTipoSolicitud || listTipoSolicitud.length === 0"
                                               [loading]="!listTipoSolicitud || listTipoSolicitud.length === 0"
                                               notFoundText="Tipo no encontrado"
                                               placeholder="-- Seleccione un Tipo --"
                                               clearAllText="Eliminar selección">

                                        <!--<ng-template ng-label-tmp let-item="item">
                                            <img src="/assets/images/TipoSolicitudEx/{{item.Id}}.png" class="bu-dropdown" />
                                            
                                            <span class="bu-descripcion">{{item.Descripcion}}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="/assets/images/TipoSolicitudEx/{{item.Id}}.png" class="bu-dropdown" />
                                            <span class="bu-descripcion">{{item.Descripcion}}</span>
                                        </ng-template>-->
                                    </ng-select>
                                </div>

                            </div>

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpNumeroCertificado">Nº Certificado Fitosanitario</label>
                                    <input formControlName="NumeroCertificado" name="NumeroCertificado" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpDescripcion">Ref. Solicitante</label>
                                    <input formControlName="RefSolicitante" name="RefSolicitante" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpPais">Punto Inspección</label>

                                    <ng-select loadingText="Cargando..."
                                               [items]="listPuntoInspeccion"
                                               placeholder="-- Seleccione un PIF --"
                                               [readonly]="!listPuntoInspeccion || listPuntoInspeccion.length === 0"
                                               [loading]="!listPuntoInspeccion || listPuntoInspeccion.length === 0"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPuntoInspeccion"
                                               notFoundText="PIF no encontrado"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFirmado">Firmado</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Firmado"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Certificados Sede Exportación SL
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultCertificadoSedeExporSl?.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)"
                                 [paginator]="true"
                                 [columns]="cols" sortField="Codigo" [rows]="resultCertificadoSedeExporSl?.PageSize" [totalRecords]="resultCertificadoSedeExporSl?.TotalCount"
                                 [loading]="loading"
                                 styleClass="table table-responsive-sm  table-striped table-sm"
                                 [ngClass]="displayGridHidden(resultCertificadoSedeExporSl?.ResultList)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display':col?.display}" [pSortableColumn]="col?.field">
                                        {{col?.header}}
                                        <p-sortIcon *ngIf="col?.field !== 'Link'" [field]="col?.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr>
                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="col.field!=='Link' && col.field!=='FechaEnvio' && col.field !== 'Firmado' ">
                                            {{rowData[col.field]}}
                                        </span>
                                        <span *ngIf="col.field==='FechaEnvio'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                        <span *ngIf="col.field === 'Firmado'">{{rowData[col.field] | siNo}}</span>
                                        <div *ngIf="col.field==='Link'" class="btn-group">
                                            <div *ngIf="checkFirmado(rowData)">
                                                <button (click)="onFirmaCF(rowData)" type="button" title="Firmar CF"
                                                        class="btn btn-sm btn-warning">
                                                    <span class="fa fa-pencil"></span>
                                                </button>
                                            </div>                                            
                                        </div>
                                    </td>
                                </tr>

                            </ng-template>

                        </p-table>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
